export const MyDailyFiveLastUpdateTimeStorageKey = "MyDailyFiveLastUpdateTime";

export const MyDailyFiveArticleIdsStorageKey = "MyDailyFiveArticleIds";

export const MyDailyFiveRecommendIdStorageKey = "MyDailyFiveRecommendId";
